import "./ArrivalsDepartures.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightToBracket,
  faArrowRightFromBracket,
  faDoorOpen,
  faDoorClosed,
} from "@fortawesome/free-solid-svg-icons";

interface Item {
  guest: string;
  roomType: string;
  roomNumber: string;
  checkInTime?: string;
  status?: string;
}

interface Props {
  arrivalsToday: Item[];
  departuresToday: Item[];
}

function getInitials(name: string) {
  return name.split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase();
}

const AVATAR_COLORS = ["#6366f1","#8b5cf6","#10b981","#f59e0b","#3b82f6","#ec4899","#14b8a6"];
function avatarColor(name: string) {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
}

function GuestRow({ item, isArrival }: { item: Item; isArrival: boolean }) {
  const color = avatarColor(item.guest);
  return (
    <div className="ad-row">
      <div className="ad-avatar" style={{ background: color }}>
        {getInitials(item.guest)}
      </div>
      <div className="ad-info">
        <span className="ad-name">{item.guest}</span>
        <span className="ad-room">{item.roomType} · Room {item.roomNumber}</span>
      </div>
      {!isArrival && (
        <div className="ad-meta">
          <span className={`ad-status ad-status-${(item.status || "").toLowerCase().replace(/\s/g, "-")}`}>
            {item.status || "—"}
          </span>
        </div>
      )}
    </div>
  );
}

export default function ArrivalsDepartures({ arrivalsToday, departuresToday }: Props) {
  return (
    <div className="ad-grid">

      {/* ARRIVALS */}
      <div className="ad-card">
        <div className="ad-card-header">
          <div className="ad-header-icon ad-header-green">
            <FontAwesomeIcon icon={faArrowRightToBracket} />
          </div>
          <div>
            <h3 className="ad-card-title">Arrivals Today</h3>
            <p className="ad-card-count">{arrivalsToday.length} guests checking in</p>
          </div>
        </div>

        {arrivalsToday.length === 0 ? (
          <div className="ad-empty">
            <FontAwesomeIcon icon={faDoorClosed} className="ad-empty-icon" />
            <p>No arrivals today</p>
          </div>
        ) : (
          <div className="ad-list">
            {arrivalsToday.map((a, i) => (
              <GuestRow key={i} item={a} isArrival={true} />
            ))}
          </div>
        )}
      </div>

      {/* DEPARTURES */}
      <div className="ad-card">
        <div className="ad-card-header">
          <div className="ad-header-icon ad-header-orange">
            <FontAwesomeIcon icon={faArrowRightFromBracket} />
          </div>
          <div>
            <h3 className="ad-card-title">Departures Today</h3>
            <p className="ad-card-count">{departuresToday.length} guests checking out</p>
          </div>
        </div>

        {departuresToday.length === 0 ? (
          <div className="ad-empty">
            <FontAwesomeIcon icon={faDoorOpen} className="ad-empty-icon" />
            <p>No departures today</p>
          </div>
        ) : (
          <div className="ad-list">
            {departuresToday.map((d, i) => (
              <GuestRow key={i} item={d} isArrival={false} />
            ))}
          </div>
        )}
      </div>

    </div>
  );
}
